// import IntersectionObserver from 'intersection-observer';

export default class Observable {
    constructor(options = {}) {
        this.options = {
            root: options.root || document.querySelector(null),
            rootMargin: options.rootMargin || `${Math.ceil(window.innerHeight * 0.7)}px 0px`,
            threshold: options.threshold || 0
        }
    }

    subscribe(selector, callback) {
        if (!callback && typeof callback !== 'function') {
            throw new Error("You must pass functions as the second parameter");
        }
        // console.log('IntersectionObserver', IntersectionObserver);
        const observer = new IntersectionObserver(((observerEntry) => {
            observerEntry.forEach((el) => {
                if (el.isIntersecting) {
                    callback(el.target);
                    observer.unobserve(el.target);
                }
            })
        }), this.options);

        if (typeof selector === 'object' && selector?.tagName) {
            observer.observe(selector);
        } else {
            const nodes = document.querySelectorAll(selector)
            if (nodes.length > 0) {
                nodes.forEach((node) => {
                    observer.observe(node);
                })
            }
        }
    }

    async load(selector, callback) {
        const elements = document.querySelectorAll(selector);

        if (elements.length > 0) {
            try {
                const { default: ImportedClass } = await callback(elements);
                if (ImportedClass) {
                    // console.log(`%c Class loaded ${ImportedClass.name}`, 'background: #222; color: #bada55');
                    return ImportedClass;
                } else {
                    // console.log(`%c we don't have export in class `, 'background: red; color: white');
                    return null;
                }
            } catch (err) {
                // console.log(`%c Fail loaded class ${selector}`, 'background: red; color: white');
                return null;
            }
        }
        // console.log(`%c page don't have selector ${selector}, don't load class`, 'background: red; color: white');
        return null;
    }
}